export default __webpack_public_path__ + "static/media/Logo.ab25b3d2.png";